import { AxiosResponse } from 'axios';
import requestClient from '../components/Utility/RequestClient';
import {
    OpenApiConfig,
    OpenApiTestRequest,
    OpenApiTestResponse,
    OpenApiConfigFormData,
    OpenApiConfigResponse,
} from '../Types';

export const openApiService = {
    getConfigs: (
        demo: boolean,
        page = 1,
        itemsPerPage = 30,
        optionalParams?: Record<string, string>,
        query: string | null = null,
    ): Promise<AxiosResponse<{ data: OpenApiConfig[]; total: number }>> => {
        return requestClient.get('/openapi/configs', {
            params: { page, itemsPerPage, query },
        });
    },

    getConfig: (identifier: string): Promise<AxiosResponse<any>> => {
        return requestClient.get(`/openapi/configs/${identifier}`);
    },
    getEndpoints: (
        identifier: string,
        page: number = 1,
        itemsPerPage: number = 10,
        query: string | null = null,
    ): Promise<AxiosResponse<{ data: any[]; total: number }>> => {
        return requestClient.get(`/openapi/configs/${identifier}/endpoints`, {
            params: { page, itemsPerPage, query },
        });
    },

    createConfig: (data: OpenApiConfigFormData): Promise<AxiosResponse<OpenApiConfigResponse>> => {
        return requestClient.post('/openapi/configs', data);
    },

    updateConfig: (identifier: string, data: OpenApiConfigFormData): Promise<AxiosResponse<OpenApiConfigResponse>> => {
        return requestClient.put(`/openapi/configs/${identifier}`, data);
    },

    deleteConfig: (identifier: string): Promise<AxiosResponse<{ message: string }>> => {
        return requestClient.delete(`/openapi/configs/${identifier}`);
    },

    testEndpoint: (identifier: string, data: OpenApiTestRequest): Promise<AxiosResponse<OpenApiTestResponse>> => {
        return requestClient.post(`/openapi/test/${identifier}`, data);
    },
};
